import React, { useEffect, useState } from "react";
import moreBtnTableIcon from "../../img/moreButtonTable.svg";
import editIcon from "../../img/editBtnIcon.svg";
import addPlusIcon from "../../img/addPlusIcon.svg";
import addPlusBlue from "../../img/addPlusBlueIcon.svg";
import imageDoc from "../../img/loadingOrderPage.png";
import printIcon from "../../img/prinBlueIcont.svg";
import CreateNewDocuments from "../ReusedComponents/CreateNewDocuments/CreateNewDocuments";
import Search from "../Search/Search";
import TableRowMenu from "../ReusedComponents/TableRowMenu/TableRowMenu";
import { onHandleShowTableMenu } from "../../utils/OnHandleShowTableMenu/OnHandleShowTableMenu";
import CreateDocSetLoadingOrderModal from "../CreateDocSetLoadingOrderModal/CreateDocSetLoadingOrderModal";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import { axiosPostAddNewCargoCase } from "../../Api/ApiCargoCase/axiosPostAddNewCargoCase";
import { axiosPutUpdateCargoCase } from "../../Api/ApiCargoCase/axiosPutUpdateCargoCase";
import useOnShowEditAddDocsButton from "../../utils/CustomHooks/useOnShowEditAddDocsButton/useOnShowEditAddDocsButton";
import UploadTemplateDocument from "../UploadTemplateDocument/UploadTemplateDocument";
import useOnSetSelectedTemplate from "../../utils/CustomHooks/useOnSetSelectedTemplate/useOnSetSelectedTemplate";
import useShowPrintTemplateButtonLoadingOrder
  from "../../utils/CustomHooks/useShowPrintTemplateButtonLoadingOrder/useShowPrintTemplateButtonLoadingOrder";
import useOnShowActiveRoutingOrders from "../../utils/CustomHooks/useOnShowActiveRoutingOrders/useOnShowActiveRoutingOrders";  
import {axiosPostAddNewRouteOrder} from "../../Api/ApiRouteOrder/axiosPostAddNewRouteOrder";
import {findStatusDocument} from "../../utils/FindStatusDocument/FindStatusDocument";
import RouteOrderModal from "../RouteOrderModal/RouteOrderModal";
import {axiosPutRouteOrder} from "../../Api/ApiRouteOrder/axiosPutRouteOrder";
import {findStatusIssuedDocuments} from "../../utils/FindStatusIssuedDocuments/findStatusIssuedDocuments";
import {axiosPostAddNewGoodsRouteOrder} from "../../Api/ApiRouteOrder/axiosPostAddNewGoodsRouteOrder";

const CargoCaseDocSetLoadingOrder = (props) => {
  const { cargoCaseDocument, isNewDocCargoCase, setIsNewDocCargoCase } = props;

  const [filter, setFilter] = useState("");
  const { auth, getRequestDataToggle, getIdCreateDoc } = useAuth();
  const [activeDocSetLoadingOrderTable, setActiveDocSetLoadingOrderTable] =
    useState(false);
  const [
    activeDocSetLoadingOrderNotFound,
    setActiveDocSetLoadingOrderNotFound,
  ] = useState(true);
  const [activeDocSetEditBnt, setActiveDocSetEditBnt] = useState(false);
  const [activeCreateLoadingOrderModal, setActiveCreateLoadingOrderModal] =
    useState(false);
  const [activeTableRowMenu, setActiveTableRowMenu] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [editDoc, setEditDoc] = useState(false);
  const [addDoc, setAddDoc] = useState(false);
  const [isBodyRequest, setIsBodyRequest] = useState({});
  const [isRouteOrdersBodyRequest, setRouteOrdersBodyRequest] = useState([]);
  const [isActiveUpdateRouteOrderModal, setActiveUpdateRouteOrderModal] = useState(false);
  const [isShowEditBtn, setShowEditBtn] = useOnShowEditAddDocsButton(
    auth,
    cargoCaseDocument
  );
  const axiosPrivate = useAxiosPrivate();
  const { isLinkTemplate} = useOnSetSelectedTemplate(auth, cargoCaseDocument[0]?.id, cargoCaseDocument[0]?.template?.id, activeDocSetLoadingOrderTable, undefined, undefined);
  const { isShowPrintButton } = useShowPrintTemplateButtonLoadingOrder(isLinkTemplate, auth, cargoCaseDocument, activeDocSetLoadingOrderTable);
  const {isShowActiveRouteOrders} = useOnShowActiveRoutingOrders(editDoc, cargoCaseDocument);
  const [totalSumWeight, setTotalSumWeight] = useState();
  // const {isOptionsTemplate} = useGetListTemplate(auth?.user?.organization, 'CARGO_CASE');

  useEffect(() => {
    let isMounted = true;

    if (isNewDocCargoCase === true) {
      isMounted && setActiveDocSetLoadingOrderTable(false);
      isMounted && setActiveDocSetLoadingOrderNotFound(true);
    } else {
      isMounted && setActiveDocSetLoadingOrderTable(true);
      isMounted && setActiveDocSetLoadingOrderNotFound(false);
    }

    return () => {
      isMounted = false;
    };
  }, [isNewDocCargoCase]);

  function onShowCurrentDoc(e) {
    e.stopPropagation();
    setActiveDocSetLoadingOrderTable(false);
    setActiveDocSetEditBnt(true);
  }

  function onShowCreateLoadingOrderModal() {
    setActiveCreateLoadingOrderModal(true);
  }

  function closeModal() {
    setAddDoc(false);
    setEditDoc(false);
    setActiveCreateLoadingOrderModal(false);
  }

  function addNewLoadingOrderCargoCase(body, itemsRouteOrder) {
    if (isNewDocCargoCase) {
      if (body.shipowner === '') {
          const newLoadingOrder = { ...cargoCaseDocument[0], ...body };
          const { bols, manifests, orders, shipowner, ...bodyRequest } = newLoadingOrder;
          console.log("1", bodyRequest);
          setIsBodyRequest(bodyRequest);
          setRouteOrdersBodyRequest(itemsRouteOrder);
          setActiveCreateLoadingOrderModal(false);
      } else {
          const newLoadingOrder = { ...cargoCaseDocument[0], ...body };
          const { bols, manifests, orders, ...bodyRequest } = newLoadingOrder;
          console.log("1", bodyRequest);
          setIsBodyRequest(bodyRequest);
          setRouteOrdersBodyRequest(itemsRouteOrder);
          setActiveCreateLoadingOrderModal(false);
      }
    } else if (addDoc) {
      if (body.shipowner === '') {
          const loadingOrder = {...body};
          const { shipowner, ...bodyRequest } = loadingOrder;
          console.log("2", loadingOrder);
          setIsBodyRequest(bodyRequest);
          setRouteOrdersBodyRequest(itemsRouteOrder);
          setActiveDocSetLoadingOrderTable(true);
          setActiveDocSetLoadingOrderNotFound(false);
          setActiveCreateLoadingOrderModal(false);
          setAddDoc(false);
          getRequestDataToggle();
      } else {
          const loadingOrder = {...body};
          console.log("2", loadingOrder);
          setIsBodyRequest(loadingOrder);
          setRouteOrdersBodyRequest(itemsRouteOrder);
          setActiveDocSetLoadingOrderTable(true);
          setActiveDocSetLoadingOrderNotFound(false);
          setActiveCreateLoadingOrderModal(false);
          setAddDoc(false);
          getRequestDataToggle();
      }
    } else if (editDoc) {
        if (body.shipowner === '') {
          const editLoadingOrder = {...body};
          const { shipowner, ...bodyRequest } = editLoadingOrder;
          console.log("3", editLoadingOrder);
          setIsBodyRequest(bodyRequest);
          setRouteOrdersBodyRequest(itemsRouteOrder);
          // setActiveDocSetEditBnt(false);
          // setActiveDocSetLoadingOrderTable(true);
          setActiveDocSetLoadingOrderNotFound(false);
          setActiveCreateLoadingOrderModal(false);
        } else {
          const editLoadingOrder = {...body};
          console.log("3", editLoadingOrder);
          setIsBodyRequest(editLoadingOrder);
          setRouteOrdersBodyRequest(itemsRouteOrder);
          // setActiveDocSetEditBnt(false);
          // setActiveDocSetLoadingOrderTable(true);
          setActiveDocSetLoadingOrderNotFound(false);
          setActiveCreateLoadingOrderModal(false);
        }
    }
  }

  function onGetRouteOrder(selectRoute) {
      if(Object.keys(selectRoute).length !== 0) {
          setRouteOrdersBodyRequest([selectRoute]);
          setActiveUpdateRouteOrderModal(true);
      } else {
          setRouteOrdersBodyRequest([]);
          setActiveUpdateRouteOrderModal(true);
      }
  }

  function onCloseRouteOrderModal() {
      setRouteOrdersBodyRequest([]);
      setActiveUpdateRouteOrderModal(false);
  }

  function onHandleGoodsRouteOrder(body) {
    const filterBodyNewItems = body.values.goods.filter(el => el.newGoods)
    const bodyGoods = [{goods: filterBodyNewItems}]
    const bodyLoadingOrder = [{
      data: {
        id: body.values.id
      }
    }]
    if(filterBodyNewItems) {
      axiosPostAddNewGoodsRouteOrder(axiosPrivate, bodyLoadingOrder, bodyGoods, cargoCaseDocument[0]?.id, getRequestDataToggle, getIdCreateDoc, setErrorMessage, setRouteOrdersBodyRequest)
    }
  }

  function onHandleRouteOrder(body) {
      const bodyRequest = {...body.values, cargoCase_id: cargoCaseDocument[0]?.id}
      const addRouteOrderRequest = [{...body.values}];
      if (body.isEdit === true) {
          axiosPutRouteOrder(
              axiosPrivate,
              body.values.id,
              bodyRequest,
              getRequestDataToggle,
              getIdCreateDoc,
              cargoCaseDocument[0]?.id,
              setErrorMessage,
              setActiveUpdateRouteOrderModal)
              onHandleGoodsRouteOrder(body);
      } else if (body.isEdit === false) {
          axiosPostAddNewRouteOrder(
              axiosPrivate,
              addRouteOrderRequest,
              cargoCaseDocument[0]?.id,
              getRequestDataToggle,
              getIdCreateDoc,
              setErrorMessage,
              setRouteOrdersBodyRequest,
              setActiveUpdateRouteOrderModal)
          setActiveUpdateRouteOrderModal(false);
      }
  }

  useEffect(() => {
    let isLoading = true;
    if (Object.keys(isBodyRequest).length !== 0 && isNewDocCargoCase === true) {
      axiosPostAddNewCargoCase(
        axiosPrivate,
        isBodyRequest,
        isLoading,
        getRequestDataToggle,
        getIdCreateDoc,
        setErrorMessage,
        setIsNewDocCargoCase,
        isRouteOrdersBodyRequest,
        setRouteOrdersBodyRequest
      );
    } else if (Object.keys(isBodyRequest).length !== 0 && editDoc === true) {
      axiosPutUpdateCargoCase(
        axiosPrivate,
        cargoCaseDocument[0]?.id,
        isBodyRequest,
        isLoading,
        getRequestDataToggle,
        getIdCreateDoc,
        setErrorMessage,
        setEditDoc,
        isRouteOrdersBodyRequest,
        setRouteOrdersBodyRequest
      );
    }

    return () => {
      isLoading = false;
    };
  }, [isBodyRequest]);
 
  function onEditActiveMode() {
    if (
       editDoc === false &&
       cargoCaseDocument[0]?.bols?.length === 0 &&
       cargoCaseDocument[0]?.manifests?.length === 0)
    {
       setActiveCreateLoadingOrderModal(true);
       setEditDoc(true);
    } else if(
        editDoc === false &&
        cargoCaseDocument[0]?.bols?.length !== 0) {
        if (findStatusIssuedDocuments(cargoCaseDocument[0]?.bols) !== true) {
            setActiveCreateLoadingOrderModal(true);
            setEditDoc(true);
        } else {
            setErrorMessage("Cargo case already have signed documents. Update impossible");
        }
    } else if(
        editDoc === false &&
        cargoCaseDocument[0]?.bols?.length !== 0 && cargoCaseDocument[0]?.manifests?.length !== 0) {
        if (findStatusIssuedDocuments(cargoCaseDocument[0]?.bols) !== true && findStatusIssuedDocuments(cargoCaseDocument[0]?.manifests) !== true) {
            setActiveCreateLoadingOrderModal(true);
            setEditDoc(true);
        } else {
            setErrorMessage("Cargo case already have signed documents. Update impossible");
        }
    } else {
      setErrorMessage("Cargo case already have signed documents. Update impossible");
    }
  }

  function addLoadingOrderCargoCase() {
    if (addDoc === false) {
      setActiveCreateLoadingOrderModal(true);
      setAddDoc(true);
    }
  }

  useEffect(() => {
    let isMount = true;

    if(cargoCaseDocument[0]?.orders?.length !== 0) {
        const getOrders = cargoCaseDocument[0]?.orders
        const getGoods = getOrders?.map(el => el?.goods);
        const getGoodsGeneralArray = getGoods?.flat();
        const totalSumGoodsGeneralArray = getGoodsGeneralArray?.map(el => el?.grossWeight)?.reduce((acc, el) => acc + el);
        isMount && setTotalSumWeight(totalSumGoodsGeneralArray)
    }

    return () => {
      isMount = false;
    }
  },[cargoCaseDocument[0]?.orders])

  return (
    <div className="cargo-case-doc-set-loading-order__container">
      <div className="cargo-case-doc-set-loading-order__title">
        <h4 className="cargo-case-doc-set-loading-order__title-name">
          Cargo case
        </h4>
        <div className="cargo-case-doc-set-loading-order__print-edit-button">
          {isShowEditBtn && (
              <div
                  onClick={() => onEditActiveMode()}
                  className={
                    activeDocSetEditBnt
                        ? "cargo-case-doc-set-loading-order__title-edit-btn"
                        : "cargo-case-doc-set-loading-order__title-edit-btn hide"
                  }
              >
                <img
                    src={editIcon}
                    className="cargo-case-doc-set-loading-order__title-icon"
                    alt={"иконка"}
                />
                <p>Edit</p>
              </div>
          )}
          {isShowPrintButton &&
              <a href={isLinkTemplate?.fileDownloadUri} className="upload-button">
                <img className="upload-button-icon" src={printIcon} alt={'icon'}/>
              </a>}
          <p className="cargo-case-doc-set-loading-order__error-message-edit-btn">
            {errorMessage}
          </p>
        </div>
      </div>
      {activeDocSetLoadingOrderNotFound ? (
        <div className="cargo-case-doc-set-loading-order__document-not-found">
          <CreateNewDocuments
            handeClickCreateNew={onShowCreateLoadingOrderModal}
            errorMessage={errorMessage}
            cargoCaseDocument={cargoCaseDocument}
            isNewDocCargoCase={isNewDocCargoCase}
          />
        </div>
      ) : (
        <div className="cargo-case-doc-set-loading-order__table">
          {activeDocSetLoadingOrderTable ? (
            <div className="cargo-case-doc-set-loading-order__table-block">
              <div className="cargo-case-doc-set-loading-order__table-block-search-add-new">
                <div className="cargo-case-doc-set-loading-order__search">
                  <Search value={filter} setValue={setFilter} />
                </div>
                {/*<div onClick={addLoadingOrderCargoCase} className="cargo-case-doc-set-loading-order__add-new-btn">*/}
                {/*    <img className="cargo-case-doc-set-loading-order__add-new-btn-icon" src={addPlusIcon} alt={'иконка плюс'}/>*/}
                {/*    <p className="cargo-case-doc-set-loading-order__name-btn">Add new</p>*/}
                {/*</div>*/}
              </div>
              <div className="cargo-case-doc-set-loading-order__table-header">
                <p>Cargo case No.</p>
                <p>Data</p>
              </div>
              {cargoCaseDocument
                .filter((el) => el?.number?.includes(filter))
                .map((el, i) => {
                  return (
                    <div
                      onClick={(e) => onShowCurrentDoc(e)}
                      key={i}
                      className="cargo-case-doc-set-loading-order__table-row"
                    >
                      <p>{el?.number}</p>
                      <p>{el?.dateOfCreation}</p>
                      <img
                        // onClick={() =>
                        //   onHandleShowTableMenu(
                        //     i,
                        //     activeTableRowMenu,
                        //     setActiveTableRowMenu
                        //   )
                        // }
                        className="cargo-case-doc-set-loading-order__btn-show-more"
                        src={moreBtnTableIcon}
                        alt={"иконка показать больше"}
                      />
                      <TableRowMenu
                        index={i}
                        activeTableRowMenu={activeTableRowMenu}
                      />
                    </div>
                  );
                })}
            </div>
          ) : (
            <div className="cargo-case-doc-set-loading-order__selected-doc">
              <div className="cargo-case-doc-set-loading-order__selected-doc-image-page">
                <img
                  className="cargo-case-doc-set-loading-order__selected-doc-image"
                  src={imageDoc}
                  alt={"изображение документа"}
                />
              </div>
              {cargoCaseDocument.map((el, i) => {
                return (
                  <div
                    key={i}
                    className="cargo-case-doc-set-loading-order__selected-doc-info"
                  >
                    <h4 className="cargo-case-doc-set-loading-order__selected-doc-info-title">
                      {el?.docInfo}
                    </h4>
                    <div className="cargo-case-doc-set-loading-order__selected-doc-info-group-input">
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>CargoCase name</label>
                        <p>{el?.number}</p>
                      </div>
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>CargoCase date</label>
                        <p>{el?.dateOfCreation}</p>
                      </div>
                    </div>
                    <div className="cargo-case-doc-set-loading-order__selected-doc-info-group-input">
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Description of goods</label>
                        <p>{el?.numberCertOfOrigin}</p>
                      </div>
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Loading window</label>
                        <p>{el?.loadingWindow}</p>
                      </div>
                    </div>
                    <div className="cargo-case-doc-set-loading-order__selected-doc-info-group-input">
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Date of arrival</label>
                        <p>{el?.estimatedTimeArrived}</p>
                      </div>
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Customs declaration Receiver</label>
                        <p>{el?.loadingOrderReceiver}</p>
                      </div>
                    </div>
                    <div className="cargo-case-doc-set-loading-order__selected-doc-info-group-input">
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Port of loading</label>
                        <p>{el?.portOfLoadingName}</p>
                      </div>
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Port of discharge</label>
                        <p>{el?.portOfDischargeName}</p>
                      </div>
                    </div>
                    <div className="cargo-case-doc-set-loading-order__selected-doc-info-group-input">
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Destination country</label>
                        <p>{el?.destinationCountry?.name}</p>
                      </div>
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Consignee</label>
                        <p>{el?.consignee}</p>
                      </div>
                    </div>
                    <div className="cargo-case-doc-set-loading-order__selected-doc-info-group-input">
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Shipper</label>
                        <p>{el?.shipperName}</p>
                      </div>
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                        <label>Additional info</label>
                        <p>{el?.label}</p>
                      </div>
                    </div>
                    <div className="cargo-case-doc-set-loading-order__selected-doc-info-group-input">
                      <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                          <label>Vessel</label>
                          <p>{el?.vesselName}</p>
                      </div>
                        {el?.vesselFlag?.name && <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                          <label>Flag</label>
                          <p>{el?.vesselFlag?.name}</p>
                      </div>}
                    </div>
                    <div className="cargo-case-doc-set-loading-order__selected-doc-info-group-input">
                        {el?.captain?.firstName && <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                          <label>Capitan</label>
                          <p>{el?.captain?.firstName} {el?.captain?.lastName}</p>
                      </div>}
                        {el?.shipowner?.name && <div className="cargo-case-doc-set-loading-order__selected-doc-info-input">
                          <label>Shipowner</label>
                          <p>{el?.shipowner?.name}</p>
                      </div>}
                    </div>
                      {cargoCaseDocument[0]?.orders?.length === 0 && <div onClick={() => onGetRouteOrder({})} className="create-doc-set-loading-order-modal-add-new-field__btn-add-new">
                          <img src={addPlusBlue} alt={'иконка плюс'} />
                          <p>Add route orders</p>
                      </div>}
                  </div>
                );
              })}
              {/*<div className="cargo-case-doc-set-loading-order__upload">*/}
              {/*  <UploadTemplateDocument*/}
              {/*      isOptionsTemplate={isOptionsTemplate}*/}
              {/*      isSelectTemplate={isSelectTemplate}*/}
              {/*      setSelectTemplate={setSelectTemplate}*/}
              {/*      isLinkTemplate={isLinkTemplate}*/}
              {/*  />*/}
              {/*</div>*/}
                {cargoCaseDocument[0]?.orders?.length !== 0 && <div className="cargo-case-doc-set-loading-order__routing-orders">
                    <div className="cargo-case-doc-set-loading-order__routing-orders-title">
                        <h4 className="cargo-case-doc-set-loading-order__routing-orders-title-name">Loading orders</h4>
                        {isShowActiveRouteOrders && isShowEditBtn && <div onClick={() => onGetRouteOrder({})} className="create-doc-set-loading-order-modal-add-new-field__btn-add-new">
                            <img src={addPlusBlue} alt={'иконка плюс'} />
                            <p>Add loading orders</p>
                        </div>}
                    </div>
                    <div className="cargo-case-doc-set-loading-order__routing-orders-table-header">
                        <p>Loading order number</p>
                        <p>Loading order date</p>
                        <p>Routing instruction</p>
                        <p>Cargo declaration</p>
                        <p>Gross weight</p>
                    </div>
                    {cargoCaseDocument[0]?.orders?.map((el) => {
                        return (
                            <div onClick={() => onGetRouteOrder(el)} key={el?.id} className={isShowActiveRouteOrders && isShowEditBtn ? "cargo-case-doc-set-loading-order__routing-orders-table-row" : "cargo-case-doc-set-loading-order__routing-orders-table-row routing-orders-table-row-not-active"}>
                                <p>{el?.number}</p>
                                <p>{el?.date}</p>
                                <p className="cargo-case-doc-set-loading-order__routing-orders-table-row-orders">
                                    {el?.goods.map((item, i) => {
                                        return (
                                            <span key={i}>{item?.importVGTD === '' ? '---' : item?.importVGTD}</span>
                                        )
                                    })}
                                </p>
                                <p className="cargo-case-doc-set-loading-order__routing-orders-table-row-orders">
                                    {el?.goods.map((item, i) => {
                                        return (
                                            <span key={i}>{item?.exportVGTD === '' ? '---' : item?.exportVGTD}</span>
                                        )
                                    })}
                                </p>
                                <p className="cargo-case-doc-set-loading-order__routing-orders-table-row-orders">
                                    {el?.goods.map((item, i) => {
                                        return (
                                            <span key={i}>{item?.grossWeight === '' ? '---' : item?.grossWeight}</span>
                                        )
                                    })}
                                </p>
                                <p>{el?.unitsType}</p>
                            </div>
                        )})}
                    <div className="cargo-case-doc-set-loading-order__routing-orders-table-row-total">
                        <p></p>
                        <p></p>
                        <p></p>
                        <p></p>
                        <p className="cargo-case-doc-set-loading-order__routing-orders-table-total">Total weight <span>{totalSumWeight}</span></p>
                    </div>
                </div>}
            </div>
          )}
        </div>
      )}
      {activeCreateLoadingOrderModal && (
        <CreateDocSetLoadingOrderModal
          editDoc={editDoc}
          cargoCaseDocument={cargoCaseDocument}
          addLoadingOrderCargoCase={addNewLoadingOrderCargoCase}
          closeModal={closeModal}
        />
      )}
    {isActiveUpdateRouteOrderModal && (
        <RouteOrderModal
            isRouteOrdersBodyRequest={isRouteOrdersBodyRequest}
            onCloseRouteOrderModal={onCloseRouteOrderModal}
            onHandleRouteOrder={onHandleRouteOrder}
        />
    )}
    </div>
  );
};
export default CargoCaseDocSetLoadingOrder;
